export class ColoresGlobales {
    static codColorBase = "colorBase";
    static codColorTextoLista = "colorTextoLista";
    static codColorImportante = "colorImportante";
    static codColorAceptado = "colorAceptado";
    constructor(base, textoLista, importante, aceptado){
        this.base = base;
        this.textoLista = textoLista;
        this.importante = importante;
        this.aceptado = aceptado;
    } 
}